import type { ComponentProps, ElementType } from 'react';

import { Typography } from '../Typography/Typography';
import { TypographyIcon } from '../TypographyIcon/TypographyIcon';

export type Props = {
  title: string;
  subtitle?: string;
  icon: ElementType;
  slotProps?: {
    title: Partial<ComponentProps<typeof Typography>>;
    subtitle?: Partial<ComponentProps<typeof Typography>>;
  };
};

export const DataAttribute = ({ icon, title, subtitle, slotProps }: Props) => {
  return (
    <TypographyIcon icon={icon} color="primary" variant="body2" {...slotProps?.title}>
      {title}
      {subtitle ? (
        <Typography
          color="primary"
          fontWeight="bold"
          variant="body2"
          title={subtitle}
          component="span"
          display="block"
          {...slotProps?.subtitle}
        >
          {subtitle}
        </Typography>
      ) : null}
    </TypographyIcon>
  );
};
